import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const TutorialsPage = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7782">
      <Navbar scrolled={scrolled} data-id="element-7783" />
      <main className="pt-24 pb-20" data-id="element-7784">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7785">
          <div className="max-w-6xl mx-auto" data-id="element-7786">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7787">
              Tutorials
            </h1>
            <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-7788">
              Coming soon! Check back later for helpful tutorials.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-7789" />
    </div>;
};